<template lang="pug">
.live__bg
  img.live__copterR.pc(src='../static/connections_liveR.png')
  img.live__copterL.pc(src='../static/connections_liveL.png')
  .live(id='live')
    .live__text.pc LIVE-ТРАНСЛЯЦИЯ
    .live__top
      button.live__button(@click='postButton("announcement")') Аплодисменты
      img.live__logo.pc(src='../static/KV_v8_neoconf.svg')
      button.live__button(@click='postButton("fireworks")') Фейерверк
    .live__bot
      <iframe class='live__video' src="https://player.vimeo.com/video/471312438" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      <iframe class='live__chat' src="https://vimeo.com/live-chat/471312438/70f1fb3b7d" width="100%" height="100%" frameborder="0"></iframe>
</template>

<script>
import axios from 'axios';
export default {
  name: 'live',
  methods: {
    async postButton(value) {
      try {
        let data = await axios.post(
          'https://eapteka.zapto.org/event',
          JSON.stringify(value)
        );

        if (data.status == 'success') {
          console.log(data.status);
        } else {
          throw new Error(data.status);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};

// $(function () {
//     $("#register").submit(function (e) {
//         e.preventDefault();

//         var name = $("#surname").val();

//         var arr = {
//             'event': 'register',
//             'name': name,
//             'company': $("#company").val(),
//             'instagram': $("#instagram").val()
//         };

//         localStorage.setItem('username', name);

//         $.ajax({
//             url: 'https://eapteka.zapto.org/event',
//             type: 'POST',
//             data: JSON.stringify(arr),
//             contentType: 'application/json; charset=utf-8',
//             dataType: 'json',
//             async: true,
//             success: function () {
//                 window.location.href = 'landing';
//             }
//         });
//     });
// });

// $(document).ready(function () {
//     $(".general-btn").click(function () {
//         var arr = {
//             'event': $(this).attr("id")
//         };

//         if (arr.event == "fireworks") {
//             arr.username = localStorage.getItem('username');
//         }

//         $.ajax({
//             url: 'https://eapteka.zapto.org/event',
//             type: 'POST',
//             data: JSON.stringify(arr),
//             contentType: 'application/json; charset=utf-8',
//             dataType: 'json',
//             async: true
//         });

//     });
// })
</script>

<style lang="sass">
.WCqmZ
  padding: 0 10px
.live__copterR,.live__copterL
  position: absolute
  z-index: 10
.live__copterR
  right: -308px
  top: 0
  animation: copterR 15s infinite
.live__copterL
  left: -245px
  top: 312px
  animation: copterR 15s infinite
@keyframes copterR
  from
    transform: rotate(0deg) translateX(100%) rotate(0deg)
  to
    transform: rotate(360deg) translateX(100%) rotate(-360deg)

@keyframes copterL
  from
    transform: rotate(0deg) translateX(-100%) rotate(0deg)
  to
    transform: rotate(-360deg) translateX(-100%) rotate(360deg)
.live
  background: #000000;
  padding: 105px 100px 80px
  display: flex
  flex-direction: column
  justify-content: center
  max-width: 1410px
  margin: 0 auto
  @media screen and (max-width: 812px)
    padding: 40px 20px
    // flex-direction: column-reverse
    max-width: 375px
  @media screen and (orientation: landscape) and (max-width: 812px)
    padding: 0px 20px 40px
  &__video
    width: 60%
    margin-right: 5px
    position: relative
    z-index: 10
    @media screen and (max-width: 812px)
      width: 100%
      margin-right: 0
      margin-bottom: 10px
      height: 49vw
  &__bg
    position: relative
    // z-index: 25
  &__chat
    width: 40%
    position: relative
    z-index: 10
    @media screen and (max-width: 812px)
      width: 100%
      height: 514px
  &__text
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 2px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    opacity: 0.3;
    margin-bottom: 28px
    text-align: center
    font-weight: bold
  &__top
    display: flex
    justify-content: space-between
    align-items: center
    position: relative
    z-index: 10
    margin-bottom: 36px
    @media screen and (max-width: 812px)
      margin-bottom: 20px

  &__button
    background: #304FFE;
    border-radius: 100px;
    width: 160px
    display: flex
    justify-content: center
    height: 40px
    align-items: center
    color: #ffffff
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 2px;
    border: 0
    position: relative
    z-index: 10
    transition: 0.3s
    &:hover
      background-color: #00bf9d
    @media screen and (max-width: 812px)
      font-size: 12px;
      line-height: 14px;
      width: 150px
      height: 46px
  &__logo
    width: 423px
    height: 143px
    @media screen and (max-width: 812px)
      width: 100%
      height: auto
      max-width: 320px
  &__bot
    height: 480px
    display: flex
    @media screen and (max-width: 812px)
      height: auto
      flex-direction: column
      margin-bottom: 0px
      position: relative
      z-index: 10
</style>
